export interface TokenResInterface {
  oSSAccessKeyId: string
  host: string
  policy: string
  signature: string
  expire: string
  key: string
  url: string
}

export class TokenRes implements TokenResInterface {
  oSSAccessKeyId: string
  host: string
  policy: string
  signature: string
  expire: string
  key: string
  url: string

  constructor(props: TokenResInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      oSSAccessKeyId: _oSSAccessKeyId,
      host: _host,
      policy: _policy,
      signature: _signature,
      expire: _expire,
      key: _key,
      url: _url,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.oSSAccessKeyId = _oSSAccessKeyId
    this.host = _host
    this.policy = _policy
    this.signature = _signature
    this.expire = _expire
    this.key = _key
    this.url = _url
  }
}
